import React from 'react';

// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';
import {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import * as parseutil from 'notebook/protocols/ParseUtil';

import {FromServerComponent} from '../MaterialConstants';

interface ComponentProps {
  raw_text: string;
  formats: Format;
}

class Component extends React.Component<ComponentProps> {
  shouldComponentUpdate(nextProps: ComponentProps): boolean {
    return this.props.raw_text !== nextProps.raw_text;
  }

  processedHTML = (): string =>
    formatters.renderHTML(this.props.raw_text, this.props.formats, {
      processText: parseutil.parseHTML,
    });

  render(): JSX.Element {
    return (
      <li
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: this.processedHTML(),
        }}
      />
    );
  }
}

interface Props {
  name: string;
  components: Array<FromServerComponent>;
  formats: Format;
}

export default class Material extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props): boolean {
    return this.props.name !== nextProps.name || this.props.components !== nextProps.components;
  }

  processedHTML = (): string =>
    formatters.renderHTML(this.props.name, this.props.formats, {
      processText: parseutil.parseHTML,
    });

  render(): JSX.Element {
    return (
      <li>
        <div
          className="material-item"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: this.processedHTML(),
          }}
        />
        <ul className="components-list">
          {Array.from(this.props.components).map((component) => (
            <Component key={component.id} raw_text={component.raw_text} formats={component.formats} />
          ))}
        </ul>
      </li>
    );
  }
}
